<template style="background-color: white;">
    <div style="background-color: white; line-height: 1.7em;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="row pl-3 pr-3" style="height: 800px;">
            <div class="col-6" style="border: 15px solid #5229cc; border-right: 15px solid #5229cc; background-color: #ccccff; display: flex; align-items: center; justify-content: center;">
                <div class="row">
                    <div class="col-12">
                        <center>
                            <table style="width: 90%; border-collapse: collapse;">
                                <tr v-for="g,index in remarks_list" :key="index">
                                    <th style="width: 30%;">
                                        <!-- {{ g.symbol }} -->
                                        <img class="svg-content" :src="g.symbol" alt="" width="12%" />
                                    </th>
                                    <th style="width: 30%; font-size: 120%; text-align: left; font-weight: bold;" class="pl-2"><strong>{{ g.remark }}</strong></th>
                                </tr>
                            </table>
                        </center>
                    </div>
                    <div class="col-12" style="margin-top: -15px;">
                        <center>
                            <center><strong>GRADE KEY</strong></center>
                            <table style="width: 90%; border: none;">
                                <tr>
                                    <td style="width:48%; vertical-align: top; text-align: left;">
                                        <table style="width: 100%; border-collapse: collapse;">
                                            <tr v-for="(g, index) in grade_details.slice(0, Math.ceil(grade_details.length / 2))" :key="g.id" v-if="g.gradename != '-'">
                                                <th style="width: 20%; font-size: 120%;padding-left: 25px; font-weight: bold;">{{ g.gradename }}</th>
                                                <th style="width: 40%; font-size: 120%; text-align: center; font-weight: bold;">{{ g.range }}</th>
                                                <th style="font-size: 120%; text-align: center; width: 40%; font-weight: bold;"><strong>{{ g.graderemark }}</strong></th>
                                            </tr>
                                        </table>
                                    </td>
                                    <td style="width: 4%; vertical-align: top;border: none !important "> </td>
                                    <td style="width: 48%; vertical-align: top; text-align: left;">
                                        <table style="width: 100%; border-collapse: collapse;">
                                            <tr v-for="(g, index) in grade_details.slice(Math.ceil(grade_details.length / 2), grade_details.length)" :key="g.id" v-if="g.gradename != '-'">
                                                <th style="width: 20%; font-size: 120%; padding-left: 25px; font-weight: bold;">{{ g.gradename }}</th>
                                                <th style="width: 40%; font-size: 120%; text-align: center; font-weight: bold;">{{ g.range }}</th>
                                                <th style="font-size: 120%; text-align: center; width: 40%;  font-weight: bold;"><strong>{{ g.graderemark }}</strong></th>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </center>
                    </div>
                </div>
            </div>
            <div class="col-6" style="border: 15px solid #5229cc; border-left: 15px solid #5229cc; background-color: #ccccff;">
                <span style="text-transform: uppercase; font-size: xx-large; font-weight: bolder; color: #450676;"> <center>{{ org_basic_data.trust_name }}</center> </span>
                <span style="color: #450676;"><center>{{ org_basic_data.address }}</center></span>
                <center><img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png" width="120px" height="120px" alt="logo" /></center>
                <center>
                    <div style="border: 5px solid #5229cc; width: 420px; height: 320px;"><img :src="marksheet_img" alt="" width="400px" height="300px" class="mt-1" style="border: 2px solid #5229cc;" /></div>
                </center>
                <br />
                <span style="text-transform: uppercase; font-size: x-large; font-weight: bolder;"> <center>Report Card</center> </span> <br />
                <div class="row pl-2" style="text-transform: uppercase; font-size: large; font-weight: bolder; margin-top: -25px;">
                    <div class="col-12 mt-2 pt-2">
                        <div class="row">
                            Name : 
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2"><span v-if="name_as_on_aadhar_card!='' && name_as_on_aadhar_card!=null">{{ name_as_on_aadhar_card }}</span> <span v-else>{{ name }} <span class="pl-1"></span> {{ sur_name }}</span></div>
                        </div>
                    </div>
                    <div class="col-6"><div class="row">std : {{ standard }}</div></div>
                    <div class="col-6"><div class="row">Div : {{ div }}</div></div>
                </div>
                <div class="mt-2 pt-2" style="text-transform: uppercase; font-size: x-large; font-weight: bolder;"><center>{{ay}}</center></div>
            </div>
        </div>
        <div class="row pagebreak pl-5 pr-5"  style="padding-top: 60px;">
            <div class="col-6">
                <div class="row" style="margin-top: -15px;">
                    <div class="col-10" style="margin-bottom: -10px;"><b style="font-size: 15px;"> Student Name: <span v-if="name_as_on_aadhar_card!='' && name_as_on_aadhar_card!=null">{{ name_as_on_aadhar_card }}</span> <span v-else>{{ name }} {{ sur_name }}</span> </b></div>
                    <div class="col-2" style="margin-bottom: -10px;"><b style="font-size: 15px;"> 1st Term </b></div>
                </div>
            </div>
            <div class="col-6">
                <div class="row" style="margin-top: -2px;">
                    <b style="font-size: 15px; margin-bottom: -10px; margin-left: 11px;"> 2nd Term </b>
                    <b style="font-size: 15px; margin-left: 130px; margin-bottom: -10px;"> Roll No.: {{ roll_no }} </b>
                    <b style="font-size: 15px; margin-left: 100px; margin-bottom: -10px;"> Class: {{ standard }} </b>
                    <b style="font-size: 15px; margin-left: 20px; margin-bottom: -10px;"> Div: {{ div }} </b>
                </div>
            </div>
            <div class="col-6 table-container" style="margin-top: -30px;">
                <table v-for="data,index1 in leraner_marksheet" :key="index1" style="height: 300px;">
                    <thead>
                        <tr>
                            <th colspan="2" v-if="index1==0" style="height: 45px;width: 400px;">
                                <div>Marks out of 100</div>
                                <div style="margin-top: -15px;">
                                    Pass Marks for each subject is 33%
                                </div>
                            </th>
                            <th colspan="2" style="width: 300px; height: 45px;">
                                {{ass_type_term_1[index1]}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th v-if="index1==0" colspan="2"></th>
                            <th style="width: 130px;">Marks</th>
                            <th style="width: 50px;">Comment</th>
                        </tr>
                        <tr v-for="s, index in data" :key="index">
                            <td colspan="2" v-if="s[0].credit == 0 && index1==0" style="text-transform: uppercase;" class="pl-2">
                                <strong>
                                    {{ index }}
                                    <span v-if="s[0].sub_marks < 100 || s[0].sub_marks > 100">{{ s[0].crs_marks }}</span>
                                </strong>
                            </td>
                            <td v-if="s[0].credit != 0 && index1==0" style="text-transform: uppercase; width: 35% !important;" class="pl-2">
                                <strong>
                                    {{ index }}
                                    <span v-if="s[0].sub_marks < 100 || s[0].sub_marks > 100">{{ s[0].crs_marks }}</span>
                                </strong>
                            </td>
                            <td style="width: 10% !important;" v-if="s[0].credit != 0 && s[0].count != 0 && index1==0" :rowspan="s[0].count">
                                <v-row dense>
                                    <span class="avg" style="margin-left: -10px; margin-top: -2px;">
                                        <!-- <img src="@/assets/marksheet_img/curly_ca.svg" /> -->
                                        <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/wws_wakad_marksheet_img/curly_ca.svg" />
                                    </span>
                                </v-row>
                            </td>

                            <td style="font-size: 12px;">
                                <center>
                                    <strong>
                                        {{ s[0].marks }}
                                    </strong>
                                </center>
                            </td>
                            <td style="height: 30px; width: 30px;">
                                <center>
                                    <strong>
                                        <!-- {{ s[0].comment }} -->
                                        <img class="svg-content_crs" :src="s[0].comment" alt="" width="80%" />
                                    </strong>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td class="pl-2" colspan="2" v-if="index1==0">
                                <strong>ATTENDANCE</strong>
                            </td>
                            <td class="diagonalCross2">
                                <span style="position: relative; font-size: 12px;" v-for="at,ind in attendance_list_sem_1[index1]" :key="ind">
                                    <span class="pl-2" style="position: relative; left: 25%; top: -5px;">
                                        <strong>
                                            {{ at.present }}
                                        </strong>
                                    </span>
                                    <span class="pt-2" style="position: absolute; left: 380%;">
                                        <strong>
                                            {{ at.total_working_stud }}
                                        </strong>
                                    </span>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="pl-2" colspan="2" v-if="index1==0">
                                <strong>Total </strong>
                            </td>
                            <td class="diagonalCross2" style="font-size: 12px;">
                                <span style="position: relative;" v-if="ass_type_hide_show_percentage[index1]">
                                    <span class="pl-1" style="position: relative; left: 25%; top: -5px;">
                                        <strong>
                                            {{ total_marks_ass_type[index1] }}
                                        </strong>
                                    </span>
                                    <span class="pt-2" style="position: absolute; left: 350%;">
                                        <strong>
                                            {{ out_off_marks_ass_type[index1] }}
                                        </strong>
                                    </span>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="pl-2" colspan="2" v-if="index1==0">
                                <strong>Percentage </strong>
                            </td>
                            <td style="font-size: 12px;">
                                <span v-if="ass_type_hide_show_percentage[index1]">
                                    <center>
                                        <strong>
                                            {{ percentage_list_ass_type[index1] }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="pl-2" colspan="2" v-if="index1==0" style="line-height: 130%;">
                                <strong>TEACHER ISSUING THE REPORT CARD </strong>
                            </td>
                            <td style="font-size: 12px;" :colspan="display_flag_avg == true ? 3 : 2">
                                <center>
                                    <strong>
                                        {{ inst_name }}
                                    </strong>
                                </center>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-6 table-container" style="margin-top: -30px;">
                <!--sem 2 data-->
                <table v-for="data,index1 in leraner_marksheet_sem_2" :key="index1" style="height: 300px;width: 250px;">
                    <thead>
                        <tr>
                            <th colspan="2" style="width: 300px; height: 45px;">
                                {{ass_type_term_2[index1]}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <th style="width: 130px;">Marks</th>
                            <th style="width: 50px;">Comment</th>
                        </tr>
                        <tr v-for="s, index in data" :key="index">
                            <td style="font-size: 12px;">
                                <center>
                                    <strong>
                                        {{ s[0].marks }}
                                    </strong>
                                </center>
                            </td>
                            <td style="height: 30px; width: 50px; font-size: 12px;">
                                <center>
                                    <strong>
                                        <!-- {{ s[0].comment }} -->
                                        <img class="svg-content_crs" :src="s[0].comment" alt="" width="80%" />
                                    </strong>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td class="diagonalCross2">
                                <span style="position: relative; font-size: 13px;" v-for="at,ind in attendance_list_sem_2[index1]" :key="ind">
                                    <span class="pl-2" style="position: relative; left: 25%; top: -5px;">
                                        <strong>
                                            {{ at.present }}
                                        </strong>
                                    </span>
                                    <span class="pt-2" style="position: absolute; left: 380%;">
                                        <strong>
                                            {{ at.total_working_stud }}
                                        </strong>
                                    </span>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="diagonalCross2">
                                <span style="position: relative; font-size: 12px;" v-if="ass_type_hide_show_percentage_sem_2[index1]">
                                    <span class="pl-2" style="position: relative; left: 25%; top: -5px;">
                                        <strong>
                                            {{ total_marks_ass_type[index1+2] }}
                                        </strong>
                                    </span>
                                    <span class="pt-2" style="position: absolute; left: 380%;">
                                        <strong>
                                            {{ out_off_marks_ass_type[index1+2] }}
                                        </strong>
                                    </span>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style="font-size: 12px;">
                                <span v-if="ass_type_hide_show_percentage_sem_2[index1]">
                                    <center>
                                        <strong>
                                            {{ percentage_list_ass_type[index1+2] }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style="font-size: 12px;" :colspan="display_flag_avg == true ? 3 : 2">
                                <center>
                                    <strong>
                                        {{ inst_name }}
                                    </strong>
                                </center>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <!--overall data table-->
                <table style="height: 300px; width: 300px;">
                    <thead>
                        <tr>
                            <th colspan="3" style="height: 45px;width:300px">
                                <div v-if="org_id=='1'">Overall Average Of Unit 1-4</div>
                                <div v-else>Overall Average</div>
                                <div style="margin-top: -15px;">{{ ay }}</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                         <tr>
                            <th style="width: 130px;">Marks</th>
                            <th style="width: 50px;">Comment</th>
                        </tr>
                        <tr v-for="ov, index in overall_data" :key="index">
                            <td style="width: 40%; font-size: 12px;">
                                <center>
                                    <strong>
                                        {{ ov.marks }}
                                    </strong>
                                </center>
                            </td>

                            <td style="height: 30px; width: 50px; font-size: 12px;">
                                <center>
                                    <strong>
                                        <!-- {{ov.comment}} -->
                                        <img class="svg-content_crs" :src="ov.comment" alt="" width="38%" />
                                    </strong>
                                </center>
                            </td>
                        </tr>
                        <tr>
                            <td class="diagonalCross2">
                                <span style="position: relative; font-size: 13px;">
                                    <span v-if="display_overall_total">
                                        <strong>
                                            <span style="position: relative; left: 25%; top: -5px;">
                                                {{ attendance_list_overall[0].present }}
                                            </span>
                                            <span class="pt-2 ml-5" style="position: absolute; left: 250%;">
                                                {{ attendance_list_overall[0].total_working_stud }}
                                            </span>
                                        </strong>
                                    </span>
                                    <span v-else>
                                        <strong>
                                            <span style="position: relative; left: 10%; top: -5px;">
                                                -
                                            </span>
                                            <span class="pt-2 ml-5" style="position: absolute; left: 500%;">
                                                -
                                            </span>
                                        </strong>
                                    </span>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="diagonalCross2">
                                <span style="position: relative; font-size: 13px;">
                                    <strong>
                                        <span style="position: relative; left: 10%; top: -5px;">
                                            -
                                        </span>
                                        <span class="pt-2 ml-5" style="position: absolute; left: 500%;">
                                            -
                                        </span>
                                    </strong>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style="font-size: 12px;">
                                <span v-if="show_hide_avg_overall">
                                    <center>
                                        <strong>
                                            {{ percentage }}
                                        </strong>
                                    </center>
                                </span>
                                <span v-else>
                                    <center>
                                        <strong> - </strong>
                                    </center>
                                </span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style="font-size: 12px;" :colspan="display_flag_avg == true ? 3 : 2">
                                <center>
                                    <strong>
                                        {{ inst_name }}
                                    </strong>
                                </center>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12" style="margin-top: -5px;">
                <div class="row pl-2 pr-5" style="margin-top: -8px; margin-left: 0.1px; height: 35px;">
                    <div style="font-size: 13px; font-family: 'Times New Roman', Times, serif; line-height: 130%;">
                        <strong>General Remark: </strong>
                        <span>{{ marksheet_remark }} </span>
                    </div>
                </div>
            </div>
            <v-row class="pt-2">
                        <v-col cols="12" sm="3" md="3" class="pl-5" style="margin-top: 40px;">
                            <div>
                            <b>Promoted To : </b>
                                <span style="border-bottom: 1px solid; display: inline-block; width: 70px;">{{ next_std }}
                                    <span  v-if="org_id=='1'">-{{ next_div }}</span>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" style="margin-left: -60px;" >
                            <div v-if="standard == 'III'" class="pt-1">
                                <strong> Initiated into__________________ House </strong>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="5" md="5" class="pl-9" align="center">
                            <div>
                            <strong>Principal's Signature</strong>
                                <span style="border-bottom: 1px solid; display: inline-block; width: 190px;text-align: left; padding-left: 20px;" >
                                        <img style="margin-top: 16px; margin-bottom: 0px;" class="pl-2" v-if="org_id=='1'"  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/wakad-removebg.png" width="110px" height="45px" alt="logo" /> 
                                        <img style="margin-top: 16px; margin-bottom: 0px;" class="pl-2" v-else  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/wws/2/chatgptimagesep22,2026,10_28_47amkz4i3o070g.png" width="110px" height="45px" alt="logo" /> 
                                </span>
                            </div>
                        </v-col>
                    </v-row>
            <!-- <div class="row ml-3" style="margin-top: 0px; font-family: 'Times New Roman', Times, serif;">
                <div class="col-8">
                    <div class="row">
                        <strong>Promoted To : </strong>
                        <div style="width: 20%; margin-left: 5px;" class="stud_details2">{{ next_std }}
                            <span v-if="org_id=='1'">-{{ next_div }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-4 pl-5">
                    <div class="row">
                        <strong>Principal's Signature</strong>
                        <div style="width: 45%; margin-left: 5px;" class="stud_details2">
                            <strong>  
                                <img v-if="org_id=='1'"  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/wakad-removebg.png" width="100px" height="50px" alt="logo" /> 
                                <img v-else  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/Ma_am_sign_for_Report_Card_1-removebg-preview%2B(1).png" width="100px" height="50px" alt="logo" /> 
                            </strong>
                        </div>
                    </div>
                </div>
                <div class="col-8" v-if="standard == 'III'" >
                    Initiated into_____________ House
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                attendance_list_sem_1: [],
                attendance_list_sem_2: [],
                ass_type_term_2: [],
                ass_type_term_1: [],
                remarks_list: [],
                ay_std_div_list: null,
                sel_ay_data: null,
                asd: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                div: null,
                ay: null,
                name: null,
                sur_name: null,
                name_as_on_aadhar_card:null,
                leraner_marksheet: [],
                leraner_marksheet_sem_2: [],
                colspan: null,
                overall_grade: null,
                remark: [],
                org_basic_data: [],
                assessment_type: null,
                grade_details: [],
                inst_name: null,
                percentage: null,
                obtained_marks: null,
                lcm_out_off_marks: null,
                totalmarks: null,
                attendance: null,
                display_flag_avg: null,
                display_flag_ca: null,
                per_cal: null,
                hide_percentage_total: null,
                ass_type_hide_show_percentage: [],
                ass_type_hide_show_percentage_sem_2: [],
                overall_data: [],
                total_marks_ass_type: [],
                out_off_marks_ass_type: [],
                percentage_list_ass_type: [],
                show_hide_avg_overall: null,
                marksheet_remark: [],
                attendance_list_overall: [],
                marksheet_img: null,
                next_std: null,
                next_div:null,
                display_overall_total: null,
                org_id:null,
                show_hide_percentage:null
            };
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.registration_no = localStorage.getItem("setreg_no");
            this.show_hide_percentage = localStorage.getItem("show_hide_percentage");
            this.org_id = localStorage.getItem("EPS-org-id")
            this.onload();
            document.addEventListener("keydown", this.handleKeyDown);
        },
        beforeDestroy() {
            // Remove the keydown event listener when the component is destroyed
            document.removeEventListener("keydown", this.handleKeyDown);
        },
        methods: {
            handleKeyDown(event) {
                // Check if the key pressed is 'P' and the Ctrl key is also pressed
                if ((event.key === "p" || event.key === "P") && (event.ctrlKey || event.metaKey)) {
                    // Prevent the default behavior (in this case, printing)
                    event.preventDefault();
                    alert("Can't take print.");
                }
            },

            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                const data = {
                    lid: this.registration_no,
                    ay: this.sel_ay_data,
                    asd: this.asd,
                    org: this.org,
                    show_hide_percentage: this.show_hide_percentage,
                };
                axios
                    .post("/WWSExamination/generatelearnermarksheetannual", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.div = res.data.div;
                            this.ay = res.data.ay;
                            this.name = res.data.name;
                            this.roll_no = res.data.roll_no;
                            this.photo = res.data.photo;
                            this.sur_name = res.data.sur_name;
                            this.name_as_on_aadhar_card = res.data.name_as_on_aadhar_card
                            this.leraner_marksheet = res.data.leraner_marksheet;
                            this.leraner_marksheet_sem_2 = res.data.leraner_marksheet_sem_2;
                            this.org_basic_data = res.data.org_basic_data;
                            this.assessment_type = res.data.assessment_type;
                            this.grade_details = res.data.grade_details;
                            this.inst_name = res.data.inst_name;
                            this.percentage = res.data.percentage;
                            this.obtained_marks = res.data.obtained_marks;
                            this.lcm_out_off_marks = res.data.lcm_out_off_marks;
                            this.totalmarks = res.data.totalmarks;
                            this.attendance = res.data.attendance;
                            this.display_flag_avg = res.data.display_flag_avg;
                            this.display_flag_ca = res.data.display_flag_ca;
                            this.per_cal = res.data.per_cal;
                            this.hide_percentage_total = res.data.hide_percentage_total;
                            this.attendance_list_sem_1 = res.data.attendance_list_sem_1;
                            this.attendance_list_sem_2 = res.data.attendance_list_sem_2;
                            this.ass_type_term_1 = res.data.ass_type_term_1;
                            this.remarks_list = res.data.remarks_list;
                            this.ass_type_term_2 = res.data.ass_type_term_2;
                            this.ass_type_hide_show_percentage = res.data.ass_type_hide_show_percentage;
                            this.ass_type_hide_show_percentage_sem_2 = res.data.ass_type_hide_show_percentage_sem_2;
                            this.overall_data = res.data.overall_data;
                            this.total_marks_ass_type = res.data.total_marks_ass_type;
                            this.out_off_marks_ass_type = res.data.out_off_marks_ass_type;
                            this.percentage_list_ass_type = res.data.percentage_list_ass_type;
                            this.show_hide_avg_overall = res.data.show_hide_avg_overall;
                            this.marksheet_remark = res.data.marksheet_remark;
                            this.attendance_list_overall = res.data.attendance_list_overall;
                            this.marksheet_img = res.data.marksheet_img;
                            this.next_std = res.data.next_std;
                            this.next_div = res.data.next_div;
                            this.display_overall_total = res.data.display_overall_total;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
    };
</script>

<style scoped>
    .diagonalCross2 {
        background: linear-gradient(to top left, #fff calc(50% - 1px), black, #fff calc(50% + 1px));
    }
    td {
        height: 30px !important;
    }
    tr,
    td,
    th,
    table {
        font-size: 10px;
        border: 0.2px solid black;
        border-collapse: separate;
        font-family: "Times New Roman", Times, serif;
    }
    .table-container {
        display: flex;
    }
    .table-container table {
        border-collapse: separate;
        border-spacing: 0;
        border: none;
    }
    div {
        font-family: "Times New Roman", Times, serif;
    }

    @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        th {
            white-space: nowrap;
        }
        .svg-content {
            width: 30%;
            /* height: 50%; */
        }
        .svg-content_crs {
            width: 80%;
            /* height: 50%; */
        }
        @page {
            size: A4 landscape !important;
            /* size: 25.5in 19in; */
            /* size: 210mm 297mm; */
            font-family: "Times New Roman", Times, serif;
            /* margin-top: -2.3mm;
            margin-bottom: -2.5mm;  
            margin-right: 3.0mm;
            margin-left: 3.0mm; */
            /* margin-top: -1.2645833mm; */
            margin: 0mm;
        }
        .pagebreak {
            page-break-before: always;
            line-height: -50px !important;
        }
    }
    .stud_details2 {
        border-bottom: 1px solid black;
        height: 25px;
    }

    /* @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        .card {
            border: none !important;
        }
        @page {
            size: A4 portrait;
            margin-top: none;
            padding-top: none;
            size: 25in 16in;
            font-family: "Times New Roman", Times, serif;
        }
    } */
</style>
